export default class UserData {
    data_key: string;
    data_value: string;

    constructor({data_key = '', data_value = ''} = {}) {
        this.data_key = data_key;
        this.data_value = data_value;
    }
}
